import { useLayoutEffect, useRef, useState } from 'preact/hooks'

/**
 * An element's width, watched while `drawn`: a line's tick labels drop out when they would crowd (`timelineTicks`),
 * so how many fit changes with the column.
 */
export function useElementWidth<T extends HTMLElement>(drawn: boolean) {
    const element = useRef<T>(null)
    const [width, setWidth] = useState(0)
    useLayoutEffect(() => {
        const node = element.current
        if (!node) return
        const report = () => setWidth(node.clientWidth)
        report()
        if (typeof ResizeObserver === 'undefined') return
        const observer = new ResizeObserver(report)
        observer.observe(node)
        return () => observer.disconnect()
    }, [drawn])
    return { element, width }
}
